var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/atoms/elevation.ts
var elevation = {
  low: {
    shadow: { boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.08)" }
  },
  high: {
    shadow: { boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.16)" }
  }
};

// src/atoms/radius.ts
var radius = {
  r0: "0",
  r4: "4px",
  r8: "8px",
  r12: "12px",
  rRound: "50%"
};

// src/atoms/spacing.ts
var spacing = {
  s4: "4px",
  s8: "8px",
  s16: "16px",
  s24: "24px",
  s32: "32px",
  s48: "48px"
};

// src/atoms/typography.ts
import { createGetFontVariationSettings } from "@instacart/ids-core";
var INSTACART_SANS_FONT_FAMILY = "Instacart Sans";
var INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS = `"${INSTACART_SANS_FONT_FAMILY}", Helvetica, Arial, sans-serif`;
var FONT_VARIATION_CONSTANTS = {
  wght: {
    normal: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800
  },
  opsz: {
    // These values are encoded into the static versions of our Instacart Sans
    // fonts. With our variable fonts we can just change this axis of variation
    // to get the same effect as changing font families.
    headline: 48,
    // Maps to Instacart Sans Headline
    subhead: 32,
    // Maps to Instacart Sans Subhead
    text: 8
    // Maps to Instacart Sans Text
  }
};
var getVariationSettings = createGetFontVariationSettings(FONT_VARIATION_CONSTANTS);
var typography = {
  headline: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 28,
    lineHeight: "32px"
  }, getVariationSettings({ wght: "semiBold", opsz: "subhead" })),
  title: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 24,
    lineHeight: "28px"
  }, getVariationSettings({ wght: "semiBold", opsz: "subhead" })),
  subtitle: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 18,
    lineHeight: "22px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })),
  bodyRegular: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })),
  bodyEmphasized: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })),
  bodyStrikethrough: __spreadProps(__spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })), {
    textDecoration: "line-through"
  }),
  bodyLink: __spreadProps(__spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" })), {
    textDecoration: "underline"
  }),
  accentRegular: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({ wght: "normal", opsz: "text" })),
  accentEmphasized: __spreadValues({
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({ wght: "semiBold", opsz: "text" }))
};

// src/atoms/theme/TDS_DEFAULT_COLORS.ts
var TDS_DEFAULT_COLORS = {
  colors: {
    systemGrayscale00: "#FFFFFF",
    systemGrayscale10: "#F6F7F8",
    systemGrayscale20: "#E8E9EB",
    systemGrayscale30: "#C7C8CD",
    systemGrayscale60: "#56595E",
    systemGrayscale80: "#242529",
    systemDetrimentalRegular: "#DE3534",
    systemDetrimentalDark: "#BB1C1B",
    systemDetrimentalExtraDark: "#AC1615",
    systemDetrimentalLight: "#FEF0F0",
    systemSuccessRegular: "#108910",
    systemSuccessDark: "#0D720D",
    systemSuccessExtraDark: "#0A610A",
    systemSuccessLight: "#E9FBE9",
    systemAlertRegular: "#F89F1A",
    systemAlertLight: "#FFFADF",
    systemInfoRegular: "#242529",
    systemInfoLight: "#FCF7F1",
    brandPrimaryRegular: "#0A5546",
    brandPrimaryDark: "#003D29",
    brandPrimaryExtraDark: "#001810",
    brandPrimaryLight: "#ECF6F3",
    brandPrimaryExtraLight: "#F5FBF9",
    dataCategory1: "#01A3AC",
    dataCategory2: "#5D5FEF",
    dataCategory3: "#7008A1",
    dataCategory4: "#EC269A",
    dataCategory5: "#003D29",
    dataSequentialSet1_1: "#01A3AC",
    dataSequentialSet1_2: "#1DBEC7",
    dataSequentialSet1_3: "#22D7E2",
    dataSequentialSet1_4: "#4BEAF3",
    dataSequentialSet1_5: "#75F7FF",
    dataSequentialSet2_1: "#5D5FEF",
    dataSequentialSet2_2: "#7C7DFF",
    dataSequentialSet2_3: "#9899FF",
    dataSequentialSet2_4: "#AFB0FF",
    dataSequentialSet2_5: "#CACFFF",
    dataSequentialSet3_1: "#7008A1",
    dataSequentialSet3_2: "#9B20D6",
    dataSequentialSet3_3: "#BE48F6",
    dataSequentialSet3_4: "#D479FF",
    dataSequentialSet3_5: "#E6B0FF",
    dataSequentialSet4_1: "#EC269A",
    dataSequentialSet4_2: "#FA54B5",
    dataSequentialSet4_3: "#FF7EC9",
    dataSequentialSet4_4: "#FFA6DA",
    dataSequentialSet4_5: "#FFD0EC",
    dataSequentialSet5_1: "#003D29",
    dataSequentialSet5_2: "#075D40",
    dataSequentialSet5_3: "#0A8C5C",
    dataSequentialSet5_4: "#23BF90",
    dataSequentialSet5_5: "#7DE4B9"
  }
};

// src/atoms/theme/TdsProvider.tsx
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { jsx } from "@emotion/react/jsx-runtime";
function TdsProvider({ children, theme }) {
  return /* @__PURE__ */ jsx(EmotionThemeProvider, { theme: theme != null ? theme : TDS_DEFAULT_COLORS, children });
}
__name(TdsProvider, "TdsProvider");

// src/atoms/theme/useTheme.ts
import { useTheme as emotionUseTheme } from "@emotion/react";
function useTheme() {
  const themeObject = emotionUseTheme();
  if (!Object.keys(themeObject).length) {
    throw new Error(`No <TdsProvider> in scope. Please add a <TdsProvider> to your component tree.`);
  }
  return themeObject;
}
__name(useTheme, "useTheme");

// src/molecules/index.ts
var placeholderMolecule = "placeholder";

// src/organisms/index.ts
var placeholderOrganism = "placeholder";
export {
  TDS_DEFAULT_COLORS,
  TdsProvider,
  elevation,
  placeholderMolecule,
  placeholderOrganism,
  radius,
  spacing,
  typography,
  useTheme
};
